import React, { Component } from 'react';

import {
    Alert,
    Button,
} from 'antd';

export const ReportIncompleteNotification = () => {
    return (
        <div style={{ textAlign: 'left', marginBottom: 0 }}>
            <Alert
                style={{ margin: '10px 0', width: 530 }}
                message={(
                    <span>
                        This report wasn't fully completed due to lack of credits
                    </span>
                )}
                action={(
                    <Button size="small" style={{ fontWeight: 600, marginLeft: 15 }}>
                        <a href="https://app.amzwatcher.com/app/account/usage/" target="_blank">See Pricing</a>
                    </Button>
                )}
                type="warning" showIcon />
        </div>
    )
}

export const FreeReportNotification = () => {
    return (
        <div style={{ textAlign: 'left', marginBottom: 0 }}>
            <Alert
                style={{ margin: '10px 0', width: 600 }}
                message={(
                    <span>
                        This is a free report which includes some broken links from the first few pages of your website. Subscribe to get a full report.
                    </span>
                )}
                action={(
                    <Button size="small" style={{ fontWeight: 600, marginLeft: 15 }}>
                        <a href="https://app.amzwatcher.com/app/pricing/" target="_blank">See Pricing</a>
                    </Button>
                )}
                type="warning" showIcon />
        </div>
    )
}
